module.exports = __webpack_public_path__ + "assets/images/06-full_2e7b079fba746169e03a41f1b257f345.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/06-full.png
// module id = 165
// module chunks = 0